import React from 'react';
import { Spinner, ProgressBar } from 'react-bootstrap';
import { useLoading } from '../../../hooks/useLoading';
import styles from './GlobalLoading.module.scss';

const GlobalLoading: React.FC = () => {
  const { loadingState } = useLoading();

  if (!loadingState.isLoading) {
    return null;
  }

  const { message, type, progress } = loadingState;

  if (type === 'spinner') {
    return (
      <div className={styles.spinnerWrapper}>
        <div className={styles.spinnerContainer}>
          <Spinner animation="border" variant="primary" />
          <div className={styles.spinnerMessage}>{message}</div>
        </div>
      </div>
    );
  }

  if (type === 'inline') {
    return (
      <div className={styles.inlineLoading}>
        <Spinner
          size="sm"
          animation="border"
          variant="primary"
          className="me-2"
        />
        <span>{message}</span>
        {progress !== undefined && (
          <ProgressBar
            now={progress}
            className="mt-2"
            style={{ height: '4px' }}
            variant="primary"
          />
        )}
      </div>
    );
  }

  // Overlay type (default)
  return (
    <div className={styles.overlayWrapper}>
      <div className={styles.overlayContent}>
        <div className={styles.loadingContainer}>
          <div className={styles.spinnerAnimation}>
            <div className={styles.spinnerRing}></div>
            <div className={styles.spinnerRing}></div>
            <div className={styles.spinnerRing}></div>
          </div>
          <div className={styles.loadingMessage}>{message}</div>
          {progress !== undefined && (
            <div className={styles.progressContainer}>
              <ProgressBar
                now={progress}
                className={styles.progressBar}
                variant="primary"
                animated
              />
              <div className={styles.progressText}>{Math.round(progress)}%</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlobalLoading;
